export const tableConfig = {
    name: 'priceTemplateSearach',
    searchFields: [
        { value: 'feeName', name: '费用名称', isFixed: true, type: 'input', span: 4 },
        { value: 'templateName', name: '模板名称', isFixed: true, type: 'input', span: 4 },
        { value: 'ruleName', name: '价格模板', isFixed: true, type: 'input', span: 4 },
        { value: 'collectUnitName', name: '汇总条件', isFixed: true, type: 'input', span: 4 },
        { value: 'templateCode', name: '模板编码', isFixed: true, type: 'input', span: 4 },
        {
            value: 'orderTypeCode',
            name: '单据类型',
            isFixed: true,
            type: 'select',
            span: 4,
            options: []
        },
        {
            value: 'businessType',
            name: '业务类型', // SYS_BMS_BUSI_TYPE
            isFixed: true,
            type: 'select',
            multiple: true,
            span: 4,
            options: []
        }
    ],
    height: 325,
    columns: [
        { prop: 'feeName', label: '费用名称' },
        { prop: 'templateName', label: '模板名称' },
        { prop: 'ruleName', label: '价格模板' },
        { prop: 'collectUnitName', label: '汇总条件' },
        { prop: 'templateCode', label: '模板编码' },
        { prop: 'orderTypeName', label: '单据类型' },
        { prop: 'businessTypeName', label: '业务类型' }
    ]
};

// 标准价格弹窗列配置
export const standardPriceTableConfig = {
    name: 'standardPriceTemplateSearach',
    searchFields: [
        { value: 'priceCode', name: '标准价格表编码', isFixed: true, type: 'input', span: 4 },
        { value: 'priceName', name: '标准价格表名称', isFixed: true, type: 'input', span: 4 },
        {
            value: 'businessUnitCode',
            name: '事业部',
            isFixed: true,
            type: 'select',
            span: 4,
            optionNum: 'ANDC_BUSINESS_ORG'
        },
        { value: 'templateCode', name: '计费模板编码', isFixed: true, type: 'input', span: 4 },
        { value: 'templateName', name: '计费模板名称', isFixed: true, type: 'input', span: 4 },
        { value: 'feeName', name: '费用名称', isFixed: true, type: 'input', span: 4 },
        { value: 'summaryCondition', name: '汇总条件', isFixed: true, type: 'input', span: 4 },
        {
            value: 'orderTypeCode',
            name: '单据类型',
            isFixed: true,
            type: 'select',
            span: 4,
            options: []
        },
        {
            value: 'businessType',
            name: '业务类型',
            isFixed: true,
            type: 'select',
            multiple: true,
            span: 4,
            options: []
        }
    ],
    height: 325,
    columns: [
        { prop: 'templateCode', label: '计费模板编码', width: 140 },
        { prop: 'templateName', label: '计费模板名称', width: 160 },
        { prop: 'feeName', label: '费用名称', width: 120 },
        { prop: 'summaryCondition', label: '汇总条件', width: 100 },
        { prop: 'orderTypeName', label: '单据类型', width: 100 },
        { prop: 'businessTypeName', label: '业务类型', width: 100 },
        { prop: 'priceCode', label: '价格表编码', width: 160 },
        { prop: 'priceName', label: '价格表名称', width: 160 },
        { prop: 'businessUnitCode', label: '事业部编码', width: 120 },
        { prop: 'businessUnitCode', label: '事业部名称', width: 120, type: 'select', optionsKey: 'ANDC_BUSINESS_ORG' },
        { prop: 'sceneName', label: '计费场景', width: 100 },
        { prop: 'priceSceneCode', label: '价格场景', width: 100, type: 'select', optionsKey: 'PMS_PRICE_SCENE' },
        { prop: 'priceNature', label: '价格性质', width: 100, type: 'select', optionsKey: 'PMS_PRICE_NATURE' },
        { prop: 'year', label: '年份', width: 80 }
    ]
};
